import React from "react";
import ConvertToPurchaseOrder from "MODULES/IncomingQuotes/Detail/ConvertToPurchaseOrder/ConvertToPurchaseOrder";
import Send from "MODULES/IncomingQuotes/Detail/Send/Send";
import DeleteIncomingQuote from "MODULES/IncomingQuotes/Detail/DeleteIncomingQuote";
import ImportIncomingQuote from "MODULES/IncomingQuotes/Detail/ImportIncomingQuote/ImportIncomingQuote";
import ActionDropDown from "MODULES/shared/components/ActionDropDown/ActionDropDown";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { loadRecord } from "MODULES/shared/decorators";
import * as actions from "MODULES/IncomingQuotes/actions";

export function Actions({ incomingQuoteWithAllLineItems: incomingQuote }) {
  return (
    <ActionDropDown
      menuClass="dropdown-menu-right"
      style={{ cursor: "pointer" }}
    >
      <ConvertToPurchaseOrder incomingQuote={incomingQuote} />
      <Send quote={incomingQuote} />
      <DeleteIncomingQuote incomingQuote={incomingQuote} />
      <ImportIncomingQuote incomingQuote={incomingQuote} />
    </ActionDropDown>
  );
}

export default withRouter(
  connect(state => ({
    incomingQuoteWithAllLineItems: state.incomingQuoteWithAllLineItemsDetail.get(
      "incomingQuoteWithAllLineItems"
    )
  }))(
    loadRecord({
      reducer: "incomingQuoteWithAllLineItemsDetail",
      name: "incomingQuoteWithAllLineItems",
      action: id => actions.fetchIncomingQuoteWithAllLineItems(id)
    })(Actions)
  )
);

Actions.propTypes = {};



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/Detail/Header/Actions.jsx